const ROTATE_NONE = 1; //no rotation, not even worth mentioning?
const ROTATE_MIRRORED = 2; //image just needs to be flipped horizontally.
const ROTATE_180  = 3;
const ROTATE_180_MIRRORED = 4;
const ROTATE_90 = 5;
const ROTATE_90_MIRRORED = 6;
const ROTATE_270 = 7;
const ROTATE_270_MIRRORED = 8;

const rotateImage = (image, orientation) => {
    return new Promise(
        (resolve, reject) => {
            try {
                let width = image.width,
                    height = image.height,
                    canvas = document.createElement('canvas'),
                    ctx = canvas.getContext("2d");

                canvas.width = width;
                canvas.height = height;
                // draw image
                ctx.drawImage(image, 0, 0);

                switch (orientation) {
                    case ROTATE_MIRRORED: ctx.transform(-1, 0, 0, 1, width, 0); break;
                    case ROTATE_180: ctx.transform(-1, 0, 0, -1, width, height); break;
                    case ROTATE_180_MIRRORED: ctx.transform(1, 0, 0, -1, 0, height); break;
                    case ROTATE_90: ctx.transform(0, 1, 1, 0, 0, 0); break;
                    case ROTATE_90_MIRRORED: ctx.transform(0, 1, -1, 0, height, 0); break;
                    case ROTATE_270: ctx.transform(0, -1, -1, 0, height, width); break;
                    case ROTATE_270_MIRRORED: ctx.transform(0, -1, 1, 0, 0, width); break;
                    default: break;
                }

                // export base64
                canvas.toBlob(
                    (blob) => {
                        resolve(blob);
                    },
                    'image/jpeg',
                    0.85
                );
            } catch(ex) {
                reject(ex);
            }
        }
    );
}

const rotateImageFromFile = (file, orientation) => {
    return new Promise(
        (resolve, reject) => {
            let img = new Image();    

            img.onload = () => {
                rotateImage(img, orientation).then(resolve).catch(reject);
            };
            img.onerror = reject;
            
            let fr = new FileReader();
            fr.onload = () => {
                img.src = fr.result;
            }
            fr.onerror = reject;
            fr.readAsDataURL(file);
        }
    )
};

export {
    rotateImage,
    rotateImageFromFile,

    ROTATE_180,
    ROTATE_180_MIRRORED,
    ROTATE_270,
    ROTATE_270_MIRRORED,
    ROTATE_90,
    ROTATE_90_MIRRORED,
    ROTATE_NONE,
    ROTATE_MIRRORED,
};